(function($) {

    // Recupère un marker par son id
    L.Map.include({
        getMarkerById: function (id) {
            var marker = null;
            this.eachLayer(function (layer) {
                if (layer instanceof L.Marker) {
                    if (layer.options.id === id) {
                        marker = layer;
                    }
                }
            });
            return marker;
        }
    });

    // Definition de la map
    var map_annuaire = L.map('map_annuaire').setView([48.385, -1.825], 11);

    L.tileLayer.provider('OpenStreetMap.France').addTo(map_annuaire);

    // Affichage des Maqueurs

    var markers = [];

    var marker_off = L.icon({
        iconUrl: pageannuaire_vars.templateUrl + '/dist/images/marker_off.png',
        iconSize:     [28,42],
    });

    var marker_on = L.icon({
        iconUrl: pageannuaire_vars.templateUrl + '/dist/images/marker_on.png',
        iconSize:     [28,42],
    });

    if( $('.list-items').length > 0){

        $('.list-items li').each(function(){

            var lat = $(this).data('lat');
            var lng = $(this).data('lng');
            var id = $(this).data('id');

            markers[id] = L.marker(
                [lat, lng],
                {
                    id: id,
                    icon: marker_off
                }
            ).addTo(map_annuaire);

            $(markers[id]).mouseenter(function (e) {
                setIn(id,false);
            }).mouseleave(function (e) {
                setOut(id,false);
            });

            $(markers[id]).click(function (e) {
                setTexte(id);
            });

        });

        // Evenements

        $('.list-items li').mouseenter(function(){
            setIn($(this).data('id'),true);
        }).mouseleave(function(){
            setOut($(this).data('id'),true);
        });

        $('.list-items li').click(function (e) {
            setTexte($(this).data('id'));
        });

        // Fonctions

        function setIn(id, pan){

            var marker = map_annuaire.getMarkerById(id);
            marker.setIcon(marker_on);

            if(pan){
                map_annuaire.panTo(marker.getLatLng());
            }

            $('.list-items li[data-id='+id+'] .annuaire-item').css({
                'background-color' : '#7dd4c9'
            });


        }

        function setOut(id){

            var marker = map_annuaire.getMarkerById(id);
            marker.setIcon(marker_off);

            $('.list-items li[data-id='+id+'] .annuaire-item').css({
                'background-color' : '#fff'
            });

        }

        function setTexte(id) {

            $('.annuaire-item-rest').hide();
            $('.annuaire-item-rest[data-id='+id+']').show();

        }

    }




})(jQuery);